import React, { useEffect } from 'react';
import { useDebouncedCallback } from 'use-debounce';
import { useFormikContext } from 'formik';
import isEmpty from 'lodash/isEmpty';

const DEBOUNCE_TIMEOUT = 500;

interface Props {
  onError: () => void;
}

const AutoSave: React.FC<Props> = ({ onError }) => {
  const formik = useFormikContext();

  const [debouncedSubmitCaller] = useDebouncedCallback(async (ctx: typeof formik) => {
    const errors = await ctx.validateForm();
    if (isEmpty(errors)) {
      await ctx.submitForm();
      ctx.setSubmitting(false);
    } else {
      onError();
    }
  }, DEBOUNCE_TIMEOUT);

  useEffect(() => {
    if (formik.dirty && !formik.isSubmitting) {
      debouncedSubmitCaller(formik);
    }
  }, [debouncedSubmitCaller, formik]);

  return null;
};

export default AutoSave;
